import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { VigenciaParametro } from '../../../containers'

const Parametros = (props) => {
  const { instalacao } = props
  return (
    <div>
      <Switch>
        <Route exact path='/instalacoes/:instalacaoId/parametros'
          render={({match}) => (
            <VigenciaParametro.Index
              instalacao={instalacao}
              match={match}
            />
          )}>
        </Route>
        <Route exact path='/instalacoes/:instalacaoId/parametros/new'
          render={({match}) => (
            <VigenciaParametro.Form
              instalacao={instalacao}
              match={match}
            />
          )}
        />
        <Route exact path='/instalacoes/:instalacaoId/parametros/:id/edit'
          render={({match}) => (
            <VigenciaParametro.Form
              instalacao={instalacao}
              match={match}
            />
          )}
        />
        <Route exact path='/instalacoes/:instalacaoId/parametros/:id'
          render={({match}) => (
            <VigenciaParametro.Show
              instalacao={instalacao}
              match={match}
            />
          )}
        />
      </Switch>
    </div>
  )
}

Parametros.propTypes = {
  instalacao: PropTypes.object.isRequired,
}

export default Parametros
